import React, { Component } from 'react';
import './PlaylistButton.scss';
import helpers from '../../../helpers';
import config from '../../../../config';

class PlaylistButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      link: ''
    };
  }

  componentDidMount() {
    window.addEventListener('changeTheme', this.update.bind(this));
    this.update();
  }

  componentWillUnmount() {
    window.removeEventListener('changeTheme', this.update.bind(this));
  }

  trackClick() {
    if (typeof window.tracker === 'undefined') {
      return false;
    }

    return window.tracker.click({
      click_type: 'exit',
      click_name: 'miniplayer_playlistknop',
      chapter_1: 'nederlandfm',
      chapter_2: helpers.getMiniplayer(this).getTheme()
    });
  }

  update() {
    const channel = helpers.getMiniplayer(this).getTheme();

    this.setState({
      active: true,
      link: config[channel].playlistUrl
    });
  }

  render() {
    const { active, link } = this.state;

    if (!active) {
      return null;
    }

    return (
      <a
        className="PlaylistButton clickitem"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Bekijk wat er eerder is afgespeeld"
        onClick={this.trackClick.bind(this)}
      >
        <svg viewBox="0 0 14 13">
          <g>
            <path d="M13.5625,1.8571402e-05 C13.8040292,1.8571402e-05 14,0.207987322 14,0.464303622 L14,1.39287372 C14,1.64919002 13.8040292,1.85715878 13.5625,1.85715878 L12.25,1.85715878 L12.25,6.87298494 C12.25,8.12014745 11.3590458,9.21437446 10.18325,9.28571959 C9.51959167,9.32501513 8.87473125,9.04209375 8.43091667,8.5155326 C7.98714583,7.98959049 7.79346458,7.2780427 7.90397708,6.58224964 C7.97005708,6.13429195 8.16032292,5.71716279 8.45028333,5.38405374 C8.739675,5.05096017 9.11621667,4.81699145 9.53150625,4.71119636 C9.84881042,4.62777053 10.1797792,4.6205153 10.4999271,4.68943378 L10.4999271,1.39285515 C10.4999271,0.623875299 11.0878104,0 11.8124271,0 L13.5625,1.8571402e-05 Z M0.4375,3.25001393 L8.75,3.25001393 C8.99152917,3.25001393 9.1875,3.04204518 9.1875,2.78572888 L9.1875,1.85715878 C9.1875,1.60084247 8.99152917,1.39287372 8.75,1.39287372 L0.4375,1.39287372 C0.195970833,1.39287372 0,1.60084247 0,1.85715878 L0,2.78572888 C0,3.04204518 0.195970833,3.25001393 0.4375,3.25001393 Z M0.4375,6.50000929 L6.125,6.50000929 C6.36652917,6.50000929 6.5625,6.29204054 6.5625,6.03572423 L6.5625,5.10715413 C6.5625,4.85083783 6.36652917,4.64286908 6.125,4.64286908 L0.4375,4.64286908 C0.195970833,4.64286908 0,4.85083783 0,5.10715413 L0,6.03572423 C0,6.29204054 0.195970833,6.50000929 0.4375,6.50000929 Z M0.4375,9.75000464 L6.125,9.75000464 C6.36652917,9.75000464 6.5625,9.54203589 6.5625,9.28571959 L6.5625,8.35714949 C6.5625,8.10083319 6.36652917,7.89286444 6.125,7.89286444 L0.4375,7.89286444 C0.195970833,7.89286444 0,8.10083319 0,8.35714949 L0,9.28571959 C0,9.54203589 0.195970833,9.75000464 0.4375,9.75000464 Z M13.5625,11.1428598 L0.4375,11.1428598 C0.195970833,11.1428598 0,11.3508285 0,11.6071448 L0,12.5357149 C0,12.7920312 0.195970833,13 0.4375,13 L13.5625,13 C13.8040292,13 14,12.7920312 14,12.5357149 L14,11.6071448 C14,11.3508285 13.8040292,11.1428598 13.5625,11.1428598 Z" />
          </g>
        </svg>
      </a>
    );
  }
}

export default PlaylistButton;
